import React from "react"
import { Container } from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import StateDataTable from "./StateDataTables"
import MetaTag from "components/Common/Meta-tag"

function States() {
  return (
    <>
      <MetaTag title={"All States"} />

      <div className="page-content">
        <Breadcrumbs title="Dashboard" breadcrumbItem="All States" />
        <Container fluid>
          <div className="container-fluid">
            <StateDataTable />
          </div>
        </Container>
      </div>
    </>
  )
}

export default States
